import { render, staticRenderFns } from "./nomoved-studentlist.vue?vue&type=template&id=196977c6"
import script from "./nomoved-studentlist.vue?vue&type=script&lang=js"
export * from "./nomoved-studentlist.vue?vue&type=script&lang=js"
import style0 from "./nomoved-studentlist.vue?vue&type=style&index=0&id=196977c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports